import { JDSBottomFooterLinkItemProps } from './generated';

export const withLogic =
  (
    Component: React.ComponentType<JDSBottomFooterLinkItemProps>
  ): React.FC<JDSBottomFooterLinkItemProps> =>
  (props: JDSBottomFooterLinkItemProps) => {
    return <Component {...props} />;
  };
